module.exports = __webpack_public_path__ + "d0a4a8c2da10d0e56b1271bf6a0d117d.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/SFFedora/SF_Fedora.ttf
// module id = I404
// module chunks = 0